import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Apply from "@/pages/Apply";
import Feed from "@/pages/Feed";
import Compose from "@/pages/Compose";
import Friends from "@/pages/Friends";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Messages from "@/pages/Messages";
import AdminDM from "@/pages/AdminDM";
import Groups from "@/pages/Groups";
import GroupDetail from "@/pages/GroupDetail";
import ForgotPassword from "@/pages/ForgotPassword";
import ChangePassword from "@/pages/ChangePassword";
import ComposeEvent from "@/pages/ComposeEvent";
import EventDetail from "@/pages/EventDetail";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function LandingOrRedirect() {
  const { user } = useAuth();
  if (user && user.id) return <Navigate to="/feed" replace />;
  return <Landing />;
}

function ShelledRoute({ children, adminOnly = false }) {
  return (
    <ProtectedRoute adminOnly={adminOnly}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingOrRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute allowMustChange>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feed"
            element={
              <ShelledRoute>
                <Feed />
              </ShelledRoute>
            }
          />
          <Route
            path="/compose"
            element={
              <ShelledRoute>
                <Compose />
              </ShelledRoute>
            }
          />
          <Route
            path="/friends"
            element={
              <ShelledRoute>
                <Friends />
              </ShelledRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ShelledRoute>
                <Messages />
              </ShelledRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ShelledRoute>
                <Profile />
              </ShelledRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ShelledRoute adminOnly>
                <Admin />
              </ShelledRoute>
            }
          />
          <Route
            path="/admin/dm"
            element={
              <ShelledRoute adminOnly>
                <AdminDM />
              </ShelledRoute>
            }
          />
          <Route
            path="/groups"
            element={
              <ShelledRoute>
                <Groups />
              </ShelledRoute>
            }
          />
          <Route
            path="/groups/:id"
            element={
              <ShelledRoute>
                <GroupDetail />
              </ShelledRoute>
            }
          />
          <Route
            path="/events/new"
            element={
              <ShelledRoute>
                <ComposeEvent />
              </ShelledRoute>
            }
          />
          <Route
            path="/events/:id"
            element={
              <ShelledRoute>
                <EventDetail />
              </ShelledRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
